import { ClientAttributes } from '@/types'
import { UpdateClientMutation } from './__generated__/update_mutation'
import { Mutation as UpdateMutation } from './update_mutation'
import { useForm } from '@/helpers/useForm'
import { Query as TableQuery } from './table_query'
import { Query as EditQuery } from './edit_query'
import { EditClientQuery } from './__generated__/edit_query'
import { Inline as Loading } from '@/components/loading'
import { Inline as Error } from '@/components/error'

type Client = EditClientQuery['clients']['nodes'][0]

interface Props {
  id: string
}

export const Form = ({ id }: Props) => {
  const {
    save,
    saveSuccess,
    formBuilder,
    queryError,
    queryLoading,
    mutationLoading
  } = useForm<UpdateClientMutation, ClientAttributes, EditClientQuery, Client>({
    id,
    initializer: client => ({
      organisationName: client.organisationName,
      address1: client.address1,
      address2: client.address2,
      address3: client.address3,
      postcode: client.postcode,
      county: client.county,
      city: client.city,
      email: client.email,
      phone: client.phone,
      clientTypeId: client.clientType.id
    }),
    query: EditQuery,
    queryKey: 'clients',
    mutation: UpdateMutation,
    resultKey: 'updateClient',
    refetchQueries: [TableQuery]
  })

  if (queryLoading) return <Loading />

  return (
    <>
      { queryError && <Error message={queryError} /> }
      <div className="flex flex-col gap-6">
        { formBuilder.buildQueryError() }
        { formBuilder.buildField({ name: 'Name', field: 'organisationName', type: 'text' }) }
        { formBuilder.buildField({ name: 'Type', field: 'clientTypeId', type: 'client-type' }) }
        <div className="grid grid-cols-3 gap-6">
          { formBuilder.buildField({ name: 'Address Line 1', field: 'address1', type: 'text' }) }
          { formBuilder.buildField({ name: 'Address Line 2', field: 'address2', type: 'text' }) }
          { formBuilder.buildField({ name: 'Address Line 3', field: 'address3', type: 'text' }) }
          { formBuilder.buildField({ name: 'City', field: 'city', type: 'text' }) }
          { formBuilder.buildField({ name: 'County', field: 'county', type: 'text' }) }
          { formBuilder.buildField({ name: 'Postcode', field: 'postcode', type: 'text' }) }
        </div>
        <div className="grid grid-cols-2 gap-6">
          { formBuilder.buildField({ name: 'Email', field: 'email', type: 'text' }) }
          { formBuilder.buildField({ name: 'Phone', field: 'phone', type: 'text' }) }
        </div>
        { formBuilder.saveButton(save, mutationLoading, saveSuccess) }
      </div>
    </>
  )
}
